<template>
  <FormItem v-bind="itemProps">
    <i-switch :value="value" @input="$emit('input', $event)"/>
  </FormItem>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    formItemProps: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    itemProps() {
      return {
        label: '支持打断',
        ...this.formItemProps,
      }
    }
  },
}
</script>